import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { CreditAgreementActions } from './credit-agreement.actions';
import { ICreditAgreementState } from './credit-agreement.state';

export const initialCreditAgreementState: ICreditAgreementState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const creditAgreementReducerFn = createReducer(
  initialCreditAgreementState,
  on(CreditAgreementActions.reset, (state: ICreditAgreementState, action) => {
    return new StateBuilder<ICreditAgreementState>(initialCreditAgreementState).build();
  }),
  on(CreditAgreementActions.updateModel, (state: ICreditAgreementState, action) => {
    return new StateBuilder<ICreditAgreementState>(state, action).build();
  }),
  on(CreditAgreementActions.load, (state: ICreditAgreementState, action) => {
    return new StateBuilder<ICreditAgreementState>(state).toLoading().build();
  }),
  on(CreditAgreementActions.loadSuccess, (state: ICreditAgreementState, action) => {
    return new StateBuilder<ICreditAgreementState>(state, action).toLoaded().build();
  }),
  on(CreditAgreementActions.submit, (state: ICreditAgreementState) => {
    return new StateBuilder<ICreditAgreementState>(state).toLoading().build();
  }),
  on(CreditAgreementActions.submitSuccess, (state: ICreditAgreementState, action) => {
    return new StateBuilder<ICreditAgreementState>(state, action).toLoaded().build();
  })
);

export function creditAgreementReducer(state: ICreditAgreementState | undefined, action: Action) {
  return creditAgreementReducerFn(state, action);
}
